module.exports = __webpack_public_path__ + "static/img/qrCode.34d0b89f.jpg";